<template>
	<div>
		<div
		 class="expect-job-detail"
		 @click="showPopup"
		>
			<span class="title-tip">谁能看到这份简历</span>
			<span class="selected-text">{{selectedText}}</span>
		</div>
		<popup v-model="showBox">
			<div class="popup-box">
				<div class="popup-title">
					<span class="title">选择能看到这份简历的招聘方范围</span>
				</div>
				<ul>
					<li
					 class="item"
					 :class="{'selected': index === selectedIndex}"
					 v-for="(item, index) in selectList"
					 :key="index"
					 @click="selectItem(index)"
					>
						<span class="text">{{item.text}}</span>
						<span class="text-tip">{{item.textTip}}</span>
						<i v-show="index === selectedIndex"></i>
					</li>
				</ul>
				<div class="division"></div>
				<div
				 class="cancel-btn"
				 @click="hidePopup"
				>取消</div>
			</div>
		</popup>
	</div>
</template>
<script>
import { Popup } from "@58fe/v5";
import * as types from "../../../store/mutation-types";
import { mapGetters } from "vuex";
export default {
	components: {
		Popup
	},
	data() {
		return {
			showBox: false,
			selectedIndex: 0, // 列表index
			selectedText: "所有招聘方",
			selectList: [
				{
					text: "所有招聘方",
					textTip: "通过营业执照或法人等认证的招聘方"
				},
				{
					text: "仅我投递的招聘方",
					textTip: "不会出现在简历库中，不会被非投递的招聘方邀约"
				}
			]
		};
	},
	computed: {
		...mapGetters(["showStatus", "pagetypeLog"])
	},
	created() {
		// 选择的index（所有招聘方是1，仅我投递是0
		this.selectedIndex = this.showStatus === 1 ? 0 : 1;
		this.$nextTick(() => {
			this.selectedText = this.selectList[this.selectedIndex].text;
		});
	},
	mounted() {
		window.clickLog &&
			window.clickLog("from=jl-postshuikeyikandao" + this.pagetypeLog);
	},
	watch: {
		showStatus(val) {
			this.selectedIndex = this.showStatus === 1 ? 0 : 1;
			this.selectedText = this.selectList[this.selectedIndex].text;
		}
	},
	methods: {
		showPopup() {
			this.showBox = true;
			window.clickLog &&
				window.clickLog(
					"from=jl-postshuikeyikandaoclick" + this.pagetypeLog
				);
		},
		hidePopup() {
			this.showBox = false;
		},
		selectItem(index) {
			if (this.selectedIndex !== index) {
				let showStatusId = index === 1 ? 0 : 1; // index和id顺序正好相反（后端文档有误）
				this.selectedText = this.selectList[index].text;
				this.$store.commit(types.SET_PRIVACY, {
					key: "showStatus",
					value: showStatusId
				});
			}
			this.hidePopup();
		}
	}
};
</script>
<style lang="scss" scoped>
@import "../../../assets/style/public.scss";
.popup-box {
	background: #ffffff;
}

.item {
	position: relative;
	margin: 0 px2rem(30px);
	padding: px2rem(25px) 0;
	height: px2rem(121px);
	text-align: center;
	border-bottom: 1px solid #e3e3e4;
	box-sizing: border-box;
	i {
		position: absolute;
		right: 0;
		top: px2rem(50px);
		width: px2rem(22px);
		height: px2rem(22px);
		background: url(../../../assets/img/ic_selected.png) no-repeat;
		background-size: contain;
	}
}

.selected {
	span {
		color: $orange;
	}
}

.item:last-child {
	border-bottom: 0;
}

.text {
	display: block;
	font-size: px2rem(34px);
	line-height: px2rem(34px);
	color: #999999;
}

.text-tip {
	font-size: px2rem(24px);
	color: #cccccc;
}

.division {
	height: 20px;
	background: #f6f6f6;
}

.cancel-btn {
	font-size: px2rem(34px);
	color: #666666;
	text-align: center;
	width: 100%;
	height: px2rem(100px);
	line-height: px2rem(100px);
}
</style>



// WEBPACK FOOTER //
// privacyCompany.vue?123836d4